import { PlatformOS } from '~/shared/constants/commonConstants'
import { createProductId } from '~/shared/helpers/createProductId'
import { getMobileOperatingSystem } from '~/shared/helpers/getMobileOperatingSystem'
import { ISubscription } from '~/shared/types/subscriptionsTypes'

const GTM_EVENT_CATEGORIES = {
  TRANSITION: 'transition',
}

const GTM_EVENTS = {
  FIRST_PAGE_COMPLETED: 'first_page_completed',
  FIRST_PAGE_COMPLETED_IOS_ONLY: 'first_page_completed_ios_only',
  EMAIL_FORM_SUBMIT: 'email_form_submit',
  EMAIL_FORM_SUBMIT_IOS_ONLY: 'email_form_submit_ios_only',
  ADD_TO_CART: 'add_to_cart',
  ADD_TO_CART_IOS_ONLY: 'add_to_cart_ios_only',
  PURCHASE: 'purchase',
  PURCHASE_IOS_ONLY: 'purchase_ios_only',
}

class GoogleAnalytics {
  private isIos = getMobileOperatingSystem() === PlatformOS.IOS

  logFirstPageCompleted(): void {
    if (!window.dataLayer) return

    window.dataLayer.push({
      event: GTM_EVENTS.FIRST_PAGE_COMPLETED,
      event_category: GTM_EVENT_CATEGORIES.TRANSITION,
    })

    if (this.isIos) {
      window.dataLayer.push({
        event: GTM_EVENTS.FIRST_PAGE_COMPLETED_IOS_ONLY,
        event_category: GTM_EVENT_CATEGORIES.TRANSITION,
      })
    }
  }

  logEmailFormSubmitted(email: string): void {
    if (!window.dataLayer) return

    window.dataLayer.push({
      event: GTM_EVENTS.EMAIL_FORM_SUBMIT,
      email,
    })

    if (this.isIos) {
      window.dataLayer.push({
        event: GTM_EVENTS.EMAIL_FORM_SUBMIT_IOS_ONLY,
        email,
      })
    }
  }

  logAddingToCart({
    mainPrices: { periodName, periodQuantity, fullPrice },
  }: ISubscription): void {
    if (!window.dataLayer) return

    window.dataLayer.push({
      event: GTM_EVENTS.ADD_TO_CART,
      ecommerce: {
        items: [
          {
            id: createProductId({
              periodName,
              periodQuantity,
              price: fullPrice,
            }),
            price: fullPrice,
          },
        ],
      },
    })

    if (this.isIos) {
      window.dataLayer.push({
        event: GTM_EVENTS.ADD_TO_CART_IOS_ONLY,
        ecommerce: {
          items: [
            {
              id: createProductId({
                periodName,
                periodQuantity,
                price: fullPrice,
              }),
              price: fullPrice,
            },
          ],
        },
      })
    }
  }

  logPurchaseCompleted({
    subscriptionId,
    price,
    productId,
    currency = 'USD',
  }: {
    subscriptionId: string
    price: number
    productId: string
    currency?: string
  }): void {
    if (!window.dataLayer) return

    window.dataLayer.push({
      event: GTM_EVENTS.PURCHASE,
      ecommerce: {
        transaction_id: subscriptionId,
        value: price,
        currency,
        items: [
          {
            id: productId,
            price,
          },
        ],
      },
    })

    if (this.isIos) {
      window.dataLayer.push({
        event: GTM_EVENTS.PURCHASE_IOS_ONLY,
        ecommerce: {
          transaction_id: subscriptionId,
          value: price,
          currency,
          items: [
            {
              id: productId,
              price,
            },
          ],
        },
      })
    }
  }
}

export const googleAnalyticsLogger = new GoogleAnalytics()
